module.exports = __webpack_public_path__ + "img/Etica II.5fdad22b.png";